var DocNote = require('../document');

module.exports = DocNote.extend({

    createHotKey: 'd',
    desc: "Doc Note",
    actionTitle: 'Doc Note',
    init: "DTN",
    iconClass: "icon-comment",
    isText: true //flag determining if doc/pg note if a text note //todo: still used?

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/models/document/noteTypes/text.js
 ** module id = 276
 ** module chunks = 0
 **/